import { render, staticRenderFns } from "./PassengersSummary.vue?vue&type=template&id=0dbd95f0&"
import script from "./PassengersSummary.vue?vue&type=script&lang=js&"
export * from "./PassengersSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports